<div class="privacy-container">
  <h3>Ochrana osobních údajů</h3>

  <h4>Zásady</h4>
  <p>Uvědomujeme si potřebu chránit osobní údaje všech uživatelů našich služeb i návštěvníků našich webových stránek. Potvrzujeme, že naše chování je v souladu se Zákonem o ochraně osobních údajů v naší domovské zemi, České republice (Zákon č. 101/200 Sb.).</p>

  <h4>Jak data sbíráme</h4>
  <p>Sbíráme a uchováváme jenom údaje, které jsou nezbytné pro poskytování podpory uživatelům našich služeb. zejména se to týká údajů, které nám sdělíte při založení uživatelského účtu. Dále používáme na webových stránkách služby Google Analytics, více informací naleznete ve článku <a href="/informace-o-cookies">Informace o cookies</a>.</p>

  <h4>Když vytváříte uživatelský účet</h4>
  <p>Účet na logical.finance, respektive na logical.codes (Oba servery spravujeme přímo. První slouží pro zobrazení článků a aplikace Asset Allocation Calculator, druhý slouží pro oddělené uložení dat pro Asset Allocation Calculator a pro uložení dat uživatelských účtů. Komunikace mezi servery je zabezpečená a interní.) vytváříte sami, když chcete využívat rozšířených funkcí aplikace Asset Allocation Calculator. Více o těchto funkcích naleznete v <a href="/tariffs" target="_blank" rel="noopener noreferrer">Uživatelské účty</a>. Pro vytvoření uživatelského účtu budeme od vás chtít emailovou adresu, jméno, příjmení a vytvoření vašeho Hlavního hesla. Pouze vy znáte své Hlavní heslo, nikdy jej neodesíláme na naše servery v nešifrované podobě. Držte je v tajnosti a nesdílejte je s ostatními.</p>

  <h4>Když nakupujete naše služby</h4>
  <p>Vyžadujeme jen informace nezbytné k provedení platby, respektive vystavení faktury.</p>

  <h4>Poskytování zákaznické podpory</h4>
  <p>Zákaznickou podporu poskytujeme pouze prostřednictvím registrovaného emailu uživatele.</p>

  <h4>Jaká jsou vaše práva</h4>
  <ul>
    <li>Máte právo na přístup k vašim osobním údajům, které sbíráme.</li>
    <li>Můžete požádat o vymazání vašich osobních údajů z našich systémů</li>
    <li>Můžete požádat o opravu/doplnění vašich údajů.</li>
    <li>Můžete vzít zpět souhlas se zpracováním osobních údajů, pokud jste jej poskytli.</li>
  </ul>

  <h4>Informace, které sdílíme my</h4>
  <p>Nesdílíme osobní údaje bez vašeho výslovného souhlasu s žádnými třetími stranami.</p>

  <h4>Externí zpracování</h4>
  <p>Můžeme sdílet anonymizované údaje o používání s poskytovateli analytických nástrojů (např. Google Analytics) s cílem vylepšovat naše služby.</p>

  <h4>Zákonné důvody</h4>
  <p>Osobní údaje sdílíme se třetími stranami pokud je přístup k takovým údajům, jejich ukládání, zveřejnění či zpracování důležité z těchto důvodů:</p>
  <ul>
    <li>Dodržení platných zákonů, nařízení, zákonných procesů nebo vymahatelných žádostí státní správy.</li>
    <li>Uplatnění podmínek našeho licenčního ujednání včetně vyšetření jeho možného porušení.</li>
    <li>Řešení možných bezpečnostních či technických problémů včetně podvodů.</li>
  </ul>
  <p>Všechny třetí strany, se kterými sdílíme osobní údaje jsou smluvně vázány dodržovat striktní bezpečnostní předpisy.</p>

  <h4>Ochrana osobních údajů</h4>
  <p>Náležitým způsobem zajišťujeme, aby se všechny typy údajů zmiňované v těchto Zásadách dostaly pouze k těm našim pověřených pracovníkům, kteří k nim musí mít přístup, aby mohli vykonávat svoji práci. Osobní údaje, které získáváme, jsou ukládány na serverech chráněných proti neautorizovanému přístupu.</p>
</div>

